import { Check, ArrowRight } from "lucide-react"
import { Section, Eyebrow } from "./Section"

const FULLCAST = [
  "Researched guest opportunities each month",
  "Guest prioritization and context",
  "Outreach templates",
  "Interview angles",
  "Host prep briefs",
  "Suggested questions",
]

const CLIENT = [
  "Final guest approval",
  "Sending outreach",
  "Scheduling",
  "Relationship-building",
  "Sales or referral follow-up",
]

export function GuestPipelineBoundary() {
  return (
    <Section>
      <div className="max-w-2xl">
        <Eyebrow>How we work together</Eyebrow>
        <h2 className="display-2 mt-4">
          We help build the pipeline. You own the relationship.
        </h2>
        <p className="mt-5 text-lg text-ink-body">
          FullCast helps identify and prioritize strategic guest opportunities,
          prepare outreach templates, and create the materials needed for strong
          conversations. The strongest invitations usually come from the host or
          their team — because the relationship begins before the recording.
        </p>
      </div>

      <div className="mt-12 grid gap-5 md:grid-cols-2">
        <div className="rounded-xl border border-hairline bg-surface p-7">
          <h3>FullCast provides</h3>
          <ul className="mt-5 space-y-3">
            {FULLCAST.map((item) => (
              <li key={item} className="flex items-start gap-3 text-ink-body">
                <Check className="mt-0.5 h-4 w-4 shrink-0 text-accent-display" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="rounded-xl border border-hairline bg-surface p-7">
          <h3>You provide</h3>
          <ul className="mt-5 space-y-3">
            {CLIENT.map((item) => (
              <li key={item} className="flex items-start gap-3 text-ink-body">
                <ArrowRight className="mt-0.5 h-4 w-4 shrink-0 text-ink-muted" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Section>
  )
}
